import { MapBounds } from "../models/map.bounds";
import { MapLatLng } from "../models/map.latlng";
import { MapMarker } from "../models/map.marker";
import { MapPoint } from "../models/map.point";
import { MapPolygon } from "../models/map.polygon";
import { MapPolyline } from "../models/map.polyline";

class Marker {
    public marker: MapMarker;
    public originalPosition: MapLatLng = new MapLatLng(0, 0);
    public originalZIndex = 1;

    constructor(marker: MapMarker) {
        this.marker = marker;
        this.originalPosition = { ...this.marker.position };
        this.originalZIndex = this.marker.zIndex;
    }
}

export class OverlapMarker {
    public map: any;
    private polygon?: MapPolygon;
    private polyline?: MapPolyline;
    private markerList = new Map<number, Marker>();
    private debug = false;
    private timerAnimate?: any;

    constructor(map: any, debug: boolean) {
        this.map = map;
        this.debug = debug;
    }

    public setMarker(marker: MapMarker) {
        // Si el marcador está ya expandido no se hace nada
        if (this.markerList.get(marker.id)) {
            return;
        }
        // Antes de nada restauro la posición original de los marcadores
        this.restoreMarkersPos();
        const centerPos = { ...marker.position };
        // Obtengo el cuadrado que contiene los marcadores cercanos
        const centerPoint = this.map.latLngToScreenPoint(marker.position);
        const swPoint = new MapPoint(centerPoint.x - 32, centerPoint.y + 32);
        const nePoint = new MapPoint(centerPoint.x + 32, centerPoint.y - 32);
        const swCorner = this.map.screenPointToLatLng(swPoint);
        const neCorner = this.map.screenPointToLatLng(nePoint);
        const markerBounds = new MapBounds(swCorner, neCorner);
        // En depuración se dibuja el cuadro de búsqueda
        if (this.debug) {
            if (this.polygon) {
                this.map.removePolygon(this.polygon);
            }
            this.polygon = this.map.addPolygon({
                strokeColor: '#ff0000',
                strokeOpacity: 0.3,
                strokeWeight: 1,
                fillColor: '#0000ff',
                fillOpacity: 0.1,
                editable: false
            });
            const nwPoint = new MapPoint(centerPoint.x - 32, centerPoint.y - 32);
            const sePoint = new MapPoint(centerPoint.x + 32, centerPoint.y + 32);
            const nwCorner = this.map.screenPointToLatLng(nwPoint);
            const seCorner = this.map.screenPointToLatLng(sePoint);
            this.map.addPolygonPoint(this.polygon, {
                dataModel: this,
                content: '',
                position: swCorner
            });
            this.map.addPolygonPoint(this.polygon, {
                dataModel: this,
                content: '',
                position: nwCorner
            });
            this.map.addPolygonPoint(this.polygon, {
                dataModel: this,
                content: '',
                position: neCorner
            });
            this.map.addPolygonPoint(this.polygon, {
                dataModel: this,
                content: '',
                position: seCorner
            });
        }
        // Obtengo los marcadores que están dentro del cuadrado
        const markers = this.map.getMarkerList();
        for (const [key, value] of markers) {
            if (markerBounds.contains(value.position) && value.visible && value.visibleCluster) {
                this.markerList.set(value.id, new Marker(value));
            }
        }
        if (this.markerList.size > 1) {
            this.map.closeInfowindowMarker();
            // Ordeno los marcadores por Id ascendente
            // this.markerList.sort((a, b) => (a.marker.id < b.marker.id) ? -1 : 1) // TODO:
            // Genero la espiral de marcadores
            let angle = 0;
            let x = centerPoint.x;
            let y = centerPoint.y;
            let r = this.markerList.size < 12 ? 48 : 32;
            const c = this.markerList.size < 12 ? 12 / this.markerList.size : 1;
            this.markerList.forEach((item, i) => {
                angle += (30 * c);
                r *= 1.04;
                i++;
                x += r * Math.cos(angle * Math.PI / 180);
                y += r * Math.sin(angle * Math.PI / 180);
                const newPos = this.map.screenPointToLatLng(new MapPoint(x, y));
                item.marker.setPosition(newPos);
                item.marker.setZIndex(99);
            });
            // Creo las líneas que unen cada marcador con la posición central
            this.polyline = this.map.addPolyline({
                color: '#ff0000',
                weight: 1,
                opacity: 0.5,
                clickable: false
            });
            this.map.addPolylinePoint(this.polyline, {
                position: centerPos
            });
            for (const [key, value] of this.markerList) {
                this.map.addPolylinePoint(this.polyline, {
                    position: value.marker.position
                });
                this.map.addPolylinePoint(this.polyline, {
                    position: centerPos
                });
            }
            if (this.timerAnimate) {
                clearInterval(this.timerAnimate);
            }
            let i = 0;
            this.timerAnimate = setInterval(() => {
                i++;
                this.markerList.forEach(item => {
                    let p = this.map.latLngToScreenPoint(item.marker.position);
                    p.x += Math.cos(i);
                    p.y += Math.sin(i);
                    item.marker.setPosition(this.map.screenPointToLatLng(p));
                });
            }, 200);
        } else {
            this.markerList = new Map<number, Marker>();
        }
    }

    public updateMarker(marker: MapMarker) {
        // Busco el marcador en la lista de marcadores expandidos
        let me = this.markerList.get(marker.id);
        if (me) {
            me.marker = marker;
            me.originalPosition = { ...marker.position };
        }
    }

    public restoreMarkersPos() {
        if (this.timerAnimate) {
            clearInterval(this.timerAnimate);
        }
        this.timerAnimate = undefined;
        if (this.polygon) {
            this.map.removePolygon(this.polygon);
            this.polygon = undefined;
        }
        if (this.polyline) {
            this.map.removePolyline(this.polyline);
            this.polyline = undefined;
        }
        this.markerList.forEach(item => {
            item.marker?.setPositionNotRefreshCluster(item.originalPosition);
            item.marker?.setZIndex(item.originalZIndex);
        });
        this.markerList = new Map<number, Marker>();
    }
}